module.exports = __webpack_public_path__ + "static/media/store.f8e30ca5.svg";